import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOneVisit, updateVisit } from 'slice/visitSlice';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const Update = () => {
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, oneData } = useSelector((state) => state.visit);

    const [formData, setFormData] = useState({
        name: '',
        rating: 5,
        counting: '',
        status: 1
    });
    const [images, setImages] = useState([]);

    useEffect(() => {
        dispatch(getOneVisit(id));
    }, [dispatch, id]);

    useEffect(() => {
        if (oneData) {
            setFormData({
                name: oneData.name || '',
                rating: oneData.rating || 5,
                counting: oneData.counting || '',
                status: oneData.status ?? 1
            });
        }
    }, [oneData]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleFileChange = (e) => {
        setImages(e.target.files);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = new FormData();
        Object.entries(formData).forEach(([key, val]) => data.append(key, val));
        if (images.length > 0) {
            for (let i = 0; i < images.length; i++) {
                data.append('images', images[i]);
            }
        }

        dispatch(updateVisit({ id, data }));
        toast.success('Place updated successfully!');
        setTimeout(() => navigate('/khajuraho/visits'), 1500);
    };

    const getImageUrl = (imgJson) => {
        try {
            const imgs = JSON.parse(imgJson);
            const backend = process.env.REACT_APP_BACKEND || 'http://localhost:8001/';
            const base = backend.endsWith('/') ? backend : backend + '/';
            return `${base}uploads/${imgs[0].trim()}`;
        } catch (e) {
            return '';
        }
    };

    return (
        <div className="container-fluid mt-5">
            <div className="mainheadig mx-4">
                <h4 className="text-white font-weight-bold">Update Place to Visit</h4>
            </div>
            <form onSubmit={handleSubmit} className="bg-white p-4 mx-4 mt-5 rounded shadow">
                <div className="row">
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="name" className="adminlables">Place Name</label>
                        <input type="text" id="name" name="name" value={formData.name} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-6 mt-2">
                        <label htmlFor="rating" className="adminlables">Rating (1-5)</label>
                        <input type="number" id="rating" name="rating" min="1" max="5" value={formData.rating} className="form-control" onChange={handleChange} required />
                    </div>
                    <div className="col-sm-6 mt-4">
                        <label htmlFor="images" className="adminlables">Update Images (Optional)</label>
                        <input type="file" id="images" className="form-control filebg" onChange={handleFileChange} multiple />
                        {oneData?.images && (
                            <div className="mt-3">
                                <p className="small text-muted mb-1">Current Image Preview:</p>
                                <img src={getImageUrl(oneData.images)} alt="" width="150" className="rounded shadow-sm" />
                            </div>
                        )}
                    </div>
                    <div className="col-sm-6 mt-4">
                        <label htmlFor="status" className="adminlables">Status</label>
                        <select id="status" name="status" value={formData.status} className="form-control" onChange={handleChange}>
                            <option value={1}>Active</option>
                            <option value={0}>Inactive</option>
                        </select>
                    </div>
                </div>
                <div className="mt-5 text-right">
                    <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
                        {loading ? 'Updating...' : 'Update Place'}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default Update;
